import React from 'react'
import { onPhoneClick } from 'src/utils/onPhoneClick'
import { Clinic as ClinicType } from '@customTypes/Clinic'
import { ReactComponent as LocationIcon } from 'src/images/icon-location.svg'
import useStyles from './clinic.styles'
import { TEST_IDS } from 'src/constants/testIds'
import { getClinicLocation } from 'src/helpers/clinic'

interface Props {
  clinic: ClinicType
}

const Clinic = ({ clinic }: Props) => {
  const classes = useStyles()
  return (
    <div className={classes.informationContainer}>
      <div className={classes.iconContainer}>
        <LocationIcon className={classes.icon} />
      </div>
      <div className={classes.infoDetailsContainer}>
        <div className={classes.header}>{clinic.officialName}</div>
        <div className={classes.description} data-test={TEST_IDS.address}>
          {getClinicLocation(clinic)}
        </div>
        {clinic.phone && (
          <div className={classes.link} onClick={() => onPhoneClick(clinic.phone)}>
            {clinic.phone}
          </div>
        )}
      </div>
    </div>
  )
}

export default Clinic
